import { parse } from '@wix/wix-vod-shared/dist/src/common/utils/query-string';

export default function getQueryParams(url) {
  if (!url) {
    return {};
  }
  const query = url.match(/(?:\?|$)([^#]*)/)[1];
  return parse(query);
}
